import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import Reporttitle from "../hqReport/Reporttitle";
import Piechart from "../hqReport/Piechart";
import Reportdatatable from "../hqReport/Reportdatatable";

function Billingreport() {
  const [invoicesByMonth, setInvoicesByMonth] = useState({
    thisMonth: 0,
    lastMonth: 0,
    twoMonthsAgo: 0,
  });

  const [monthlyPaidStatusCounts, setMonthlyPaidStatusCounts] = useState({
    thisMonth: { paid: 0, outstanding: 0 },
    lastMonth: { paid: 0, outstanding: 0 },
    twoMonthsAgo: { paid: 0, outstanding: 0 }
  });

  const [monthlyPaidStatusAmounts, setMonthlyPaidStatusAmounts] = useState({
    thisMonth: { paid: 0, outstanding: 0 },
    lastMonth: { paid: 0, outstanding: 0 },
    twoMonthsAgo: { paid: 0, outstanding: 0 }
  });



  return (
    <div className="favbg">
      <div className="innerwrapper Favourites_search">
        <div className="customscroll reportcustoms">
          <Reporttitle />
          <Piechart invoicesByMonth={invoicesByMonth} monthlyPaidStatusCounts={monthlyPaidStatusCounts} monthlyPaidStatusAmounts={monthlyPaidStatusAmounts} />
          <Reportdatatable setInvoicesByMonth={setInvoicesByMonth} setMonthlyPaidStatusCounts={setMonthlyPaidStatusCounts} setMonthlyPaidStatusAmounts={setMonthlyPaidStatusAmounts} />
        </div>
      </div>
    </div>
  );
}

export default Billingreport;
